import { render, staticRenderFns } from "./Dasaibaoming.vue?vue&type=template&id=38744909&scoped=true&"
import script from "./Dasaibaoming.vue?vue&type=script&lang=js&"
export * from "./Dasaibaoming.vue?vue&type=script&lang=js&"
import style0 from "./Dasaibaoming.vue?vue&type=style&index=0&id=38744909&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38744909",
  null
  
)

export default component.exports